module.exports = __webpack_public_path__ + "img/display.87514ccd.png";